import * as Types from '../constants/Types';

export const getListInventory = (params) => ({ type: Types.INVENTORY_GET_LIST_ACTION, params });
export const setListInventory = (data) => ({ type: Types.INVENTORY_GET_LIST_SUCCESS, ...(data || {}) });

export const getInventoryDetail = (id, payload = {}) => ({ type: Types.INVENTORY_DETAIL_ACTION, id, ...payload });
export const setInventoryDetail = (inventory) => ({ type: Types.INVENTORY_DETAIL_SUCCESS, inventory });
export const updateInventory = (inventory) => ({ type: Types.INVENTORY_DETAIL_UPDATE_ACTION, inventory });
export const createInventory = (inventory) => ({ type: Types.INVENTORY_DETAIL_CREATE_ACTION, inventory });
export const deleteInventory = (inventory, refreshParams) => ({ type: Types.INVENTORY_DETAIL_DELETE_ACTION, inventory, refreshParams });
